<template>
  <div :aria-hidden="!isCollageProduct"
       ref="builder"
       tabindex="0"
       class="flex-grow relative flex overflow-hidden z-10"
       :class="wrapperPaddingClasslist">
    <div v-if="enableOffline && isPetPortraitProduct" class="absolute top-0 left-0 w-full flex items-center justify-center mt-5 z-20">
      <div class="mx-4 text-center bg-gray-200 px-3 py-2 rounded">
        {{ $t('message.builder.petPortraits.offlineNotification') }}
      </div>
    </div>
    <transition name="transition-slide-fade-bottom-delay">
      <div data-preview-toggler
           v-if="showDimensionControls"
           aria-hidden="true"
           class="flex items-stretch space-x-2 absolute right-0 top-0 items-center z-20 m-1 sm:m-2">
        <div v-if="!isArt" class="pl-4 text-sm py-2 text-gray-700 items-center">{{ $t('message.builder.preview.label') }}</div>
        <div v-if="!isArt" class="relative bg-gray-100 text-gray-700 rounded-full flex font-bold tracking-wide select-none shadow p-1 sm:p-0">
          <div class="px-2 z-10 rounded-full flex items-center space-x-1 sm:py-1"
               :class="showPreview ? 'cursor-pointer' : ''"
               @click="togglePreview(false)"
          >
            <vue-feather type="square"
                         class="w-4 h-4"></vue-feather>
            <p>{{ $t('message.builder.preview.2D') }}</p>
          </div>
          <div class="px-2 z-10 rounded-full flex items-center space-x-1 sm:py-1"
               :class="!showPreview ? 'cursor-pointer' : ''"
               @click="togglePreview(true)"
          >
            <vue-feather type="box"
                         class="w-4 h-4"></vue-feather>
            <p>{{ $t('message.builder.preview.3D') }}</p>
          </div>
          <div class="h-full w-1/2 bg-white absolute left-0 top-0 rounded-full transition-all transform"
               :class="showPreview ? 'translate-x-full' : ''"
               data-preview-bg>

          </div>
        </div>
        <button v-if="canShowAR" class="btn bg-gray-100 text-gray-600 font-bold py-1 px-2 rounded flex items-center space-x-1 cursor-pointer shadow"
             @click="handlePreviewInAr"
        >
          <svg class="w-5 h-5" viewBox="0 0 92 84">
            <defs>
              <filter color-interpolation-filters="auto" id="filter-1">
                <feColorMatrix
                    color-interpolation-filters="sRGB"
                    type="matrix"
                    values="0.22 0   0   0   0
                      0   0.25  0   0   0
                      0   0   0.32  0   0
                      0   0   0   1   0 "/>
              </filter>
              <path d="M55.796806,0 L55.796806,25.951 L82.203194,10.7057714 L91.203194,26.2942286 L64.865806,41.499 L91.203194,56.7057714 L82.203194,72.2942286 L55.796806,57.048 L55.796806,84 L37.796806,84 L37.796806,57.128 L9.79680602,73.2942286 L0.796806022,57.7057714 L28.865806,41.499 L0.796806022,25.2942286 L9.79680602,9.70577137 L37.796806,25.871 L37.796806,0 L55.796806,0 Z" id="path-2"></path>
            </defs>
            <g id="Apple-AR-icon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="AR-icon" filter="url(#filter-1)">
                <g>
                  <g id="inside-3-lines-thick" transform="translate(14.399994, 4.500000)" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="3">
                    <line x1="42.3205081" y1="31" x2="32" y2="37" id="Line-4"></line>
                    <line x1="63.3205081" y1="19" x2="53" y2="25" id="Line-4-Copy-7"></line>
                    <line x1="11.3205081" y1="49" x2="1" y2="55" id="Line-4-Copy-8"></line>
                    <line x1="32" y1="37" x2="32" y2="47" id="Line-4-Copy"></line>
                    <line x1="32" y1="64" x2="32" y2="74" id="Line-4-Copy-3"></line>
                    <line x1="32" y1="0" x2="32" y2="10" id="Line-4-Copy-4"></line>
                    <line x1="22.644101" y1="31.6526509" x2="32" y2="37" id="Line-4-Copy-2"></line>
                    <line x1="0.644101002" y1="18.6526509" x2="10" y2="24" id="Line-4-Copy-5"></line>
                    <line x1="54.644101" y1="49.6526509" x2="64" y2="55" id="Line-4-Copy-6"></line>
                  </g>
                  <g id="Inside-thin-lines" transform="translate(13.000000, 3.000000)" opacity="0.5" stroke="#FFFFFF" stroke-linecap="square">
                    <line x1="33.5" y1="0.5" x2="33.5" y2="76.5" id="Line"></line>
                    <line x1="0.323215126" y1="19.4401962" x2="66.6498854" y2="57.6511218" id="Line-2"></line>
                    <line x1="0.319056777" y1="57.6432353" x2="66.6779901" y2="19.3796851" id="Line-3"></line>
                  </g>
                  <g id="Polygon">
                    <polygon id="Polygon-thin" stroke="#FFFFFF" opacity="0.5" points="46.5 3 79.841978 22.25 79.841978 60.75 46.5 80 13.158022 60.75 13.158022 22.25"></polygon>
                    <mask id="mask-3" fill="white">
                      <use xlink:href="#path-2"></use>
                    </mask>
                    <g id="mask-6-angles"></g>
                    <polygon id="Polygon-thick" stroke="#FFFFFF" stroke-width="3" mask="url(#mask-3)" points="46.5 3 79.841978 22.25 79.841978 60.75 46.5 80 13.158022 60.75 13.158022 22.25"></polygon>
                  </g>
                </g>
              </g>
            </g>
          </svg>
          <p data-module-analytics-track-click data-module-analytics-category="builder" data-module-analytics-action="click"
             data-module-analytics-label="Open AR Preview" data-module-analytics-value="1">{{ $t('message.builder.preview.AR') }}</p>
        </button>
      </div>
    </transition>
    <Printable
      :panels="panels"
      :width="selectedWidth"
      :height="selectedHeight"
      :edge-dimension="edgeDimension"
      :edge-color="edgeColor"
      :render-mode="renderMode"
      :frame="frameDimension"
      :gap="gapDimension"
      :mat="matDimension"
      :isMobile="isMobile"
      :selectedEditToolId="selectedEditToolId"
      :wrapperPaddingClasslist="wrapperPaddingClasslist"
    >
      <Panes
        :panes="panes"
        :width="selectedWidth"
        :height="selectedHeight"
        :edge="edgeDimension"
        :edge-color="edgeColor"
        :border="borderDimension"
        :border-color="borderColorValue"
        :images="images"
        :events="!showPreview"
        :upload-later="uploadLater"
        :render-mode="renderMode"
        :is-art="isArt"
        :product-slug="productSlug"
        :disable-collage-outer-border="disableCollageOuterBorder"
        :filter="liveFilterAvailable(selectedFilter) ? selectedFilter : null"
        :featureFlags="featureFlags"
        :selectedEditToolId="selectedEditToolId"
        :imageEditTrigger="imageEditTrigger"
        :locale="locale"
        @paneClick="handlePaneClick"
      />
    </Printable>
    <Previews
      aria-hidden="true"
      tabindex="-1"
      :selectedEditToolId="selectedEditToolId"
      :events="showPreview"
      :visible="showPreview"
      :width="selectedWidth"
      :height="selectedHeight"
      :frame="frameDimension"
      :gap="gapDimension"
      :mat="matDimension"
      :render-mode="renderMode"
      :can-manipulate="productSlug !== PRODUCT_ART_SINGLE_PANEL && productSlug !== PRODUCT_COLLAGE_FRAMED_PRINT"
      :feature-flags="featureFlags"
      :can-edit="canEdit"
      :frame-color="frameColor"
      :preview="showPreview"
      :isMobile="isMobile"
      :isArt="isArt"
      :panels="panels"
      :edge="edgeDimension"
      :frameType="selectedFrame"
      :enableScaleAnimation="false"
    >
    </Previews>
  </div>
  <div :key="'flyout' + selectedEditToolId"
       class="flex flex-col-reverse md:flex-col md:w-2/5 md:border-l md:flex-grow-0 md:flex-shrink-0 lg:w-1/3 z-20 relative z-20">
    <transition name="transition-slide-fade-bottom-delay">
      <div v-if="canEdit && selectedEditToolId && isMobile"
           class="pointer-events-auto">
        <ImageEditor :isMobile="isMobile"></ImageEditor>
      </div>
    </transition>
    <transition name="transition-slide-fade-bottom-delay">
    <div
      data-test-id="tabs"
        v-if="(!selectedEditToolId && isMobile) || !isMobile"
      class="relative z-10 md:flex md:flex-col md:flex-grow md:overflow-hidden"
    >
      <div role="tablist"
           aria-label="Customizable Options"
           class="relative bg-white flex z-10 items-center border-t md:border-t-0">
        <IconButton
            v-if="layouts && Object.keys(layouts).length"
            role="tab"
            :id="'tab-' + 99"
            :aria-controls="'panel-' + 99"
            data-test-id="tab-button-layouts"
            :fixed="false"
            icon="layout"
            :label="$t('message.builder.iconButtons.layouts')"
            :active="showFlyout === 99 || (showFlyoutDesktop === 99 && !isMobile)"
            :aria-selected="String(showFlyout === 99 || (showFlyoutDesktop === 99 && !isMobile))"
            @click="toggleFlyout(99)"
        />
        <IconButton
          v-if="!isCollageProduct && !isArt"
          role="tab"
          data-test-id="tab-button-image"
          :fixed="false"
          data-show-image-selector
          icon="image"
          :label="$t('message.builder.iconButtons.image')"
          aria-selected="false"
          aria-label="Choose an image"
          @click="handleShowImageSelector"
        />
        <IconButton
          v-if="!isPetPortraitProduct || isPetPortraitProduct && isMobile"
          role="tab"
          :id="'tab-' + 0"
          :aria-controls="'panel-' + 0"
          data-test-id="tab-button-sizes"
          :fixed="false"
          :icon="'maximize'"
          :label="$t('message.builder.iconButtons.sizes')"
          :active="showFlyout === 0 || (showFlyoutDesktop === 0 && !isMobile)"
          :aria-selected="String(showFlyout === 0 || (showFlyoutDesktop === 0 && !isMobile))"
          @click="toggleFlyout(0)"
        />
        <IconButton
            v-if="isPetPortraitProduct && !isMobile"
            role="tab"
            :id="'tab-' + 0"
            :aria-controls="'panel-' + 0"
            :fixed="false"
            :icon="'feather'"
            :label="$t('message.builder.iconButtons.personalize')"
            :active="showFlyout === 0 || (showFlyoutDesktop === 0 && !isMobile)"
            :aria-selected="String(showFlyout === 0 || (showFlyoutDesktop === 0 && !isMobile))"
            @click="toggleFlyout(0)"
        />
        <IconButton
            v-if="isPetPortraitProduct && isMobile"
            role="tab"
            :id="'tab-' + 4"
            :aria-controls="'panel-' + 4"
            data-pet-portrait-icon-styles
            :fixed="false"
            icon="feather"
            :label="$t('message.builder.iconButtons.styles')"
            :active="showFlyout === 4"
            :aria-selected="String(showFlyout === 4)"
            @click="toggleFlyout(4)"
        />
        <IconButton
          v-if="borders && Object.keys(borders).length"
          role="tab"
          :id="'tab-' + 88"
          :aria-controls="'panel-' + 88"
          data-test-id="tab-button-borders"
          :fixed="false"
          icon="grid"
          :label="$t('message.builder.iconButtons.borders')"
          :active="showFlyout === 88 || (showFlyoutDesktop === 88 && !isMobile)"
          :aria-selected="String(showFlyout === 88 || (showFlyoutDesktop === 88 && !isMobile))"
          @click="toggleFlyout(88)"
        />
        <IconButton
          v-if="!isPetPortraitProduct && (showEdgeOptions || showFrameOptions)"
          role="tab"
          :id="'tab-' + 1"
          :aria-controls="'panel-' + 1"
          data-test-id="tab-button-edges"
          :fixed="false"
          icon="square"
          :label="$t('message.builder.iconButtons.edges')"
          :active="showFlyout === 1 || (showFlyoutDesktop === 1 && !isMobile)"
          :aria-selected="String(showFlyout === 1 || (showFlyoutDesktop === 1 && !isMobile))"
          @click="toggleFlyout(1)"
        />
        <IconButton
          v-if="filters && Object.keys(filters).length"
          role="tab"
          :id="'tab-' + 2"
          :aria-controls="'panel-' + 2"
          data-test-id="tab-button-filters"
          :fixed="false"
          icon="sliders"
          :label="$t('message.builder.iconButtons.filters')"
          :active="showFlyout === 2 || (showFlyoutDesktop === 2 && !isMobile)"
          :aria-selected="String(showFlyout === 2 || (showFlyoutDesktop === 2 && !isMobile))"
          @click="toggleFlyout(2)"
        />
        <IconButton
          v-if="!isPetPortraitProduct"
          role="tab"
          :id="'tab-' + 3"
          :aria-controls="'panel-' + 3"
          data-test-id="tab-button-services"
          :fixed="false"
          icon="user-check"
          :label="$t('message.builder.iconButtons.services')"
          :active="showFlyout === 3 || (showFlyoutDesktop === 3 && !isMobile)"
          :aria-selected="String(showFlyout === 3 || (showFlyoutDesktop === 3 && !isMobile))"
          @click="toggleFlyout(3)"
        />
        <IconButton
            v-if="isPetPortraitProduct && isMobile"
            role="tab"
            :id="'tab-' + 5"
            :aria-controls="'panel-' + 5"
            data-pet-portrait-icon-name
            :fixed="false"
            icon="type"
            :label="$t('message.builder.iconButtons.name')"
            :active="showFlyout === 5"
            :aria-selected="String(showFlyout === 5)"
            @click="toggleFlyout(5)"
        />
        <IconButton
          v-if="isPetPortraitProduct && isMobile"
          role="tab"
          :id="'tab-' + 6"
          :aria-controls="'panel-' + 6"
          data-pet-portrait-icon-notes
          :fixed="false"
          icon="edit-2"
          :label="$t('message.builder.iconButtons.notes')"
          :active="showFlyout === 6"
          :aria-selected="String(showFlyout === 6)"
          @click="toggleFlyout(6)"
        />
      </div>
      <Flyout
        v-click-off="{ method: closeFlyout, args: [0] }"
        data-sizes
        :aria-labelledby="'tab-' + 0"
        :id="'panel-' + 0"
        role="tabpanel"
        :heading="$t('message.builder.flyout.sizes.heading')"
        :mobile-active="showFlyout === 0"
        :active="showFlyoutDesktop === 0"
        :aria-expanded="showFlyoutDesktop === 0 || showFlyout === 0"
        @close="closeFlyout(0)"
      >
        <div class="flex md:flex-col md:w-full md:border md:rounded">
          <template v-if="loading && Object.keys(filteredSuggestedSizes).length === 0">
            <Option
              v-for="n in 5"
              :key="n"
              placeholder
            />
          </template>
          <template v-else>
            <Option
              v-for="(size, key, index) in filteredSuggestedSizes"
              :key="key"
              data-test-id="size"
              :heading="size.label"
              :supplementaryHeading="getAdditionalLengthHeading(size.width, size.height)"
              :subheading="(panels === 3) ? size.sublabel : ''"
              :selected="selectedSize === key && !customSize"
              :image="require(`@vuedir/assets/sizes/${productSlug}/${getThumbnailAspectRatio(size)}_${getThumbnailSize(size, index)}.jpg`)"
              :class="index === 0 ? '' : 'ml-4 md:ml-0 md:border-t'"
              @click="handleSelectSize(size)"
            />
            <Option
              v-if="hasCustomSizes && !isSingleSize && !isPetPortraitProduct"
              data-test-id="size-custom"
              data-custom-size
              :heading="$t('message.builder.customSizeButton')"
              :subheading="customSizeTriptychSublabel"
              :image="require(`@vuedir/assets/sizes/${productSlug}/${aspectRatio}_custom.jpg`)"
              :selected="customSize"
              class="ml-4 md:ml-0 md:border-t"
              @click="handleSelectCustomSize"
            />
          </template>
        </div>
        <template
          v-if="customSize"
          v-slot:secondary
        >
          <div
            v-if="customSizesOptions"
            class="flex py-4 mt-2 border-t md:mt-0"
          >
            <Dropdown
              data-test-id="custom-sizes-options"
              class="w-full mr-1"
              :label="$t('message.builder.flyout.sizes.customSizes.widthAndHeight')"
              :options="customSizesOptions"
              :selected="selectedSize"
              @changeEvent="handleCustomSize"
            />
          </div>
          <div
            v-else
            class="py-4 mt-2 border-t md:mt-0"
          >
            <div class="flex">
              <Dropdown
                  class="w-full mr-1"
                  :label="$t('message.builder.flyout.sizes.customSizes.width')"
                  :options="customWidths"
                  :selected="selectedWidth.toString()"
                  @changeEvent="handleCustomWidth"
              />
              <Dropdown
                  class="w-full ml-1"
                  :label="$t('message.builder.flyout.sizes.customSizes.height')"
                  :options="customHeights"
                  :selected="selectedHeight.toString()"
                  @changeEvent="handleCustomHeight"
              />
            </div>
            <div v-html="getAdditionalLengthHeading(selectedWidth, selectedHeight)"
                 class="text-center text-xs md:text-sm mt-1">
            </div>
          </div>
        </template>
      </Flyout>
      <Flyout
        v-if="layouts"
        v-click-off="{ method: closeFlyout, args: [99] }"
        data-layouts
        :aria-labelledby="'tab-' + 99"
        :id="'panel-' + 99"
        role="tabpanel"
        :heading="$t('message.builder.flyout.layouts')"
        :mobile-active="showFlyout === 99"
        :active="showFlyoutDesktop === 99"
        :aria-expanded="showFlyoutDesktop === 99 || showFlyout === 99"
        @close="closeFlyout(99)"
      >
      <div v-for="(layout, key) in layouts"
           class="flex justify-center md:w-1/3 xl:w-1/4 mr-4 md:mr-0 md:mb-3 md:overflow-visible"
           @click="handleSelectLayout(layout)"
           @keyup.enter="handleSelectLayout(layout)">
          <LayoutThumbnail
              :layout="layout"
              :selected="selectedLayout === key"
              :customWidth="selectedWidth"
              :customHeight="selectedHeight"
              :customSize="customSize"
              tabindex="0"
              role="option"
              :aria-selected="String(selectedLayout === key)"
          />
        </div>
      </Flyout>
      <Flyout
        v-if="borders"
        v-click-off="{ method: closeFlyout, args: [88] }"
        data-borders
        :aria-labelledby="'tab-' + 88"
        :id="'panel-' + 88"
        role="tabpanel"
        :heading="$t('message.builder.flyout.borders')"
        :mobile-active="showFlyout === 88"
        :active="showFlyoutDesktop === 88"
        :aria-expanded="showFlyoutDesktop === 88 || showFlyout === 88"
        @close="closeFlyout(88)"
      >
        <div class="flex md:flex-col md:w-full md:border md:rounded">
          <Option
            v-for="(border, key, index) in borders"
            :key="`${selectedBorderColor}_${key}${borderDynamicThumbpath}`"
            data-test-id="border"
            :heading="border.description"
            :price="border.foreignPrice"
            :discounted-price="hasDiscount ? (border.foreignPrice * discountFactor) : null"
            :selected="selectedBorder === key"
            :image="require(`@vuedir/assets/borders/${productSlug}/${selectedBorderColor}_${key}${borderDynamicThumbpath}.jpg`)"
            :class="index === 0 ? '' : 'ml-4 md:ml-0 md:border-t'"
            @click="handleSelectBorder(border)"
            @keyup.enter="handleSelectBorder(border)"
          />
        </div>
        <div class="flex ml-4 md:flex-col md:w-full md:border md:rounded md:ml-0 md:mt-4">
          <Option
            v-for="(borderColor, key, index) in borderColors"
            :key="`${key}_${borderColorDynamicThumbpath}`"
            data-test-id="borderColor"
            :heading="borderColor.description"
            :price="borderColor.foreignPrice"
            :discounted-price="hasDiscount ? (borderColor.foreignPrice * discountFactor) : null"
            :selected="selectedBorderColor === key"
            :image="require(`@vuedir/assets/borders/${productSlug}/${key}_${borderColorDynamicThumbpath}.jpg`)"
            :class="index === 0 ? '' : 'ml-4 md:ml-0 md:border-t'"
            @click="handleSelectBorderColor(borderColor)"
            @keyup.enter="handleSelectBorderColor(borderColor)"
          />
        </div>
      </Flyout>
      <Flyout
        v-click-off="{ method: closeFlyout, args: [1] }"
        data-edges
        :aria-labelledby="'tab-' + 1"
        :id="'panel-' + 1"
        role="tabpanel"
        :heading="$t('message.builder.flyout.edgesFrames')"
        :mobile-active="showFlyout === 1"
        :active="showFlyoutDesktop === 1"
        :aria-expanded="showFlyoutDesktop === 1 || showFlyout === 1"
        @close="closeFlyout(1)"
      >
        <div v-if="!isCollageCanvasProduct" class="flex md:flex-col md:w-full md:border md:rounded">
          <Option
            v-for="(edge, key, index) in edges"
            :key="`${key}_${selectedFrame}`"
            data-test-id="edge"
            data-edge
            :disabled="!allowedEdges[key]"
            :heading="edge.description"
            :price="currentEdges[key].foreignPrice"
            :discounted-price="hasDiscount ? (currentEdges[key].foreignPrice * discountFactor) : null"
            :selected="selectedEdge === key"
            :image="require(`@vuedir/assets/edges/${productSlug}/${key}${edgeFrameThumbnailPath}.jpg`)"
            :class="index === 0 ? '' : 'ml-4 md:ml-0 md:border-t'"
            @click="handleSelectEdge(edge)"
            @keyup.enter="handleSelectEdge(edge)"
          />
        </div>
        <div class="flex ml-4 md:flex-col md:w-full md:border md:rounded md:ml-0 md:mt-4">
          <Option
            v-for="(frame, key, index) in supportedFrames"
            :key="`${key}_${selectedEdge}`"
            data-test-id="frame"
            data-frame
            :heading="frame.description"
            :price="framePriceDifference(currentFrames[key])"
            :discounted-price="hasDiscount ? (framePriceDifference(currentFrames[key]) * discountFactor) : null"
            :selected="selectedFrame === key"
            :image="require(`@vuedir/assets/frames/${productSlug}/${key}${frameEdgeThumbnailPath}.jpg`)"
            :class="index === 0 ? '' : 'ml-4 md:ml-0 md:border-t'"
            @click="handleSelectFrame(frame)"
            @keyup.enter="handleSelectFrame(frame)"
          />
        </div>
      </Flyout>
      <Flyout
        v-if="filters"
        v-click-off="{ method: closeFlyout, args: [2] }"
        data-filters
        :aria-labelledby="'tab-' + 2"
        :id="'panel-' + 2"
        role="tabpanel"
        :heading="$t('message.builder.flyout.filters.heading')"
        :mobile-active="showFlyout === 2"
        :active="showFlyoutDesktop === 2"
        :aria-expanded="showFlyoutDesktop === 2 || showFlyout === 2"
        @close="closeFlyout(2)"
      >
        <Option
          v-if="filters"
          data-test-id="filter-none"
          data-filter-none
          compact
          :heading="$t('message.builder.flyout.filters.blankOption')"
          :image="require(`@vuedir/assets/filters/filter_none.jpg`)"
          :selected="!selectedFilter"
          class="mr-4 md:mr-0"
          @click="handleSelectFilter({ code: null })"
          @keyup.enter="handleSelectFilter({ code: null })"
        />
        <Option
          v-for="(filter, key, index) in filters"
          :key="key"
          data-test-id="filter"
          compact
          :heading="filter.description"
          :supplementaryHeading="liveFilterAvailable(key) ? '(Preview available)' : ''"
          :price="filter.foreignPrice"
          :discounted-price="hasDiscount ? (filter.foreignPrice * discountFactor) : null"
          :selected="selectedFilter === key"
          :image="require(`@vuedir/assets/filters/filter_${key}.jpg`)"
          :class="index === 0 ? '' : 'ml-4 md:ml-0'"
          @click="handleSelectFilter(filter)"
          @keyup.enter="handleSelectFilter(filter)"
        />
      </Flyout>
      <Flyout
        v-click-off="{ method: closeFlyout, args: [3] }"
        data-services
        :aria-labelledby="'tab-' + 3"
        :id="'panel-' + 3"
        role="tabpanel"
        :heading="$t('message.builder.flyout.services.heading')"
        :mobile-active="showFlyout === 3"
        :active="showFlyoutDesktop === 3"
        :aria-expanded="showFlyoutDesktop === 3 || showFlyout === 3"
        @close="closeFlyout(3)"
      >
        <div class="flex md:flex-col md:w-full md:border md:rounded">
          <Option
            v-if="services"
            data-test-id="service-none"
            data-service-none
            :heading="$t('message.builder.flyout.services.noneOption')"
            :image="require(`@vuedir/assets/services/service_none.jpg`)"
            :selected="!selectedService"
            @click="handleSelectService({ code: null })"
            @keyup.enter="handleSelectService({ code: null })"
          />
          <Option
            v-for="(service, key) in services"
            :key="key"
            data-test-id="service"
            :heading="service.label"
            :subheading="service.description"
            :price="service.foreignPrice"
            :discounted-price="hasDiscount ? (service.foreignPrice * discountFactor) : null"
            :selected="selectedService === key"
            :image="require(`@vuedir/assets/services/service_${key}.jpg`)"
            class="ml-4 md:ml-0 md:border-t"
            @click="handleSelectService(service)"
            @keyup.enter="handleSelectService(service)"
          />
        </div>
        <template v-slot:secondary>
          <div :class="this.layouts ? 'flex w-full py-4 mt-2 md:mt-0': 'flex w-full py-4 mt-2 border-t md:mt-0'">
            <Textfield
              id="instructions"
              data-test-id="instructions"
              name="instructions"
              :label="$t('message.builder.flyout.services.inputLabel')"
              :placeholder="$t('message.builder.flyout.services.inputPlaceholder')"
              class="w-full"
              :value="note"
              :required="requiresNotes"
              :error="requiresNotes && !hasNote"
              @inputEvent="handleNoteChange"
            />
          </div>
        </template>
      </Flyout>
      <Flyout
          v-click-off="{ method: closeFlyout, args: [5] }"
          data-pet-notes
          :aria-labelledby="'tab-' + 5"
          :id="'panel-' + 5"
          role="tabpanel"
          :heading="petInputContent.petName.heading"
          :mobile-active="showFlyout === 5"
          :aria-expanded="showFlyout === 5"
          @close="closeFlyout(5)"
      >
        <div class="w-full">
          <label
              for="petName"
              class="text-black cursor-pointer block mb-1">
            {{ petInputContent.petName.inputLabel }}
          </label>
          <div class="flex w-full space-x-2 mb-1 md:mb-0">
            <input
                id="petName"
                type="text"
                name="petName"
                minlength="1"
                v-model="petName"
                data-name
                :placeholder="petInputContent.petName.placeholder"
                class="form-input"
            >
            <ActionButton data-change-name-cta
                          :label="'Change'"
                          :secondary="true"
                          :disabled="petPortraitName === petName"
                          @click="handleNameChange"></ActionButton>
          </div>
        </div>
      </Flyout>
      <Flyout
          v-click-off="{ method: closeFlyout, args: [6] }"
          data-notes
          :aria-labelledby="'tab-' + 6"
          :id="'panel-' + 6"
          role="tabpanel"
          :heading="petInputContent.petNotes.heading"
          :mobile-active="showFlyout === 6"
          :aria-expanded="showFlyout === 6"
          @close="closeFlyout(6)"
      >
        <div class="w-full">
          <i18n-t keypath="message.builder.petPortraits.notes.inputPrompt" class="text-sm" scope="global">
            <template v-slot:inputPromptEmphasis>
              <span class="italic">{{ petInputContent.petNotes.inputPromptEmphasis }}</span>
            </template>
          </i18n-t>
          <p class="text-sm">{{ $t('message.builder.petPortraits.notes.inputInstructionsMobile') }}</p>
          <div class="flex py-4 mt-2 md:mt-0">
            <Textfield
                id="notesMobile"
                data-notes
                name="notesMobile"
                :label="petInputContent.petNotes.inputLabel"
                :placeholder="petInputContent.petNotes.placeholder"
                class="w-full"
                :value="note"
                :required="false"
                @inputEvent="handleNoteChange"
            />
          </div>
        </div>
      </Flyout>
    </div>
    </transition>
    <transition name="transition-slide-fade-bottom-delay">
      <div v-if="(!selectedEditToolId && isMobile) || !isMobile"
           class="text-center p-4 pt-0 md:p-2 md:bg-white md:border-t">
        <div
            v-if="showPreview && isCollageProduct && !canAddToCart"
            class="p-2 bg-blue-50 text-blue-500 text-xs border border-blue-500 rounded mb-2 cursor-pointer"
            @click="togglePreview(false)"
        >
          {{ $t('message.builder.notifications.selectIn2D') }}
        </div>
        <div
            v-if="uploadLater"
            class="p-2 bg-blue-50 text-blue-500 text-xs border border-blue-500 rounded mb-2"
        >
          {{ $t('message.builder.notifications.provideImageLater') }}
        </div>
        <ActionButton
            data-test-id="add-to-cart"
            class="btn btn--secondary w-full"
            ref="backButton"
            :label="$t('message.tileBuilder.backToBundle')"
            :disabled="!canSaveChanges"
            @click="saveTileChanges"
        />
      </div>
    </transition>
  </div>
  <button class="absolute top-0 left-0 z-10 btn bg-gray-100 text-gray-700 font-bold rounded flex items-center cursor-pointer shadow m-2 p-2"
          @click="saveTileChanges" aria-hidden="true">
    <vue-feather type="chevron-left"
                 class="w-7 h-7"></vue-feather>
  </button>
</template>

<script>
import * as dimensions from '@vuedir/constants/dimensions'
import * as errors from '@vuedir/constants/errors'
import * as routes from '@vuedir/constants/routes'
import * as measurements from '@vuedir/constants/measurements'
import { mapGetters, mapActions } from 'vuex'
import clickOffDirective, { LOADING_PROCESSING_IMAGE } from '@vuedir/directives/ClickOff'
import { locale } from '@vuedir/plugins/i18n/i18n'

import ActionButton from '@vuedir/components/ActionButton'
import Body from '@vuedir/components/Body'
import Dialog from '@vuedir/components/Dialog'
import Dropdown from '@vuedir/components/Dropdown'
import Flyout from '@vuedir/components/Flyout'
import Header from '@vuedir/components/Header'
import IconButton from '@vuedir/components/IconButton'
import ImageSelector from '@vuedir/components/ImageSelector'
import Loader from '@vuedir/components/Loader'
import Menu from '@vuedir/components/Menu'
import MenuItem from '@vuedir/components/MenuItem'
import Option from '@vuedir/components/Option'
import { Printable, Panes, Previews, Textfield, supportsAR, sanitizeSvg, serializeSvg, trapTabFocus, parseSvg, products } from '@canvaspop/scoops'
import LayoutThumbnail from '@vuedir/components/LayoutThumbnail'
import Checkmark from '@vuedir/components/Checkmark'
import Styles from '@vuedir/components/Styles'
import ImageEditor from '@vuedir/components/ImageEditor'
import Tile from '@vuedir/components/Tile'
import { getService, getFilter } from '@vuedir/utils/builder-utils'
import VueFeather from 'vue-feather';

/**
 * @const {HTMLBodyElement}
 */
const body = document.querySelector('body')

/**
 * Builder.vue
 */
export default {
  directives: {
    'click-off': clickOffDirective,
  },
  components: {
    ActionButton,
    Body,
    Dialog,
    Dropdown,
    Flyout,
    Header,
    IconButton,
    ImageSelector,
    Loader,
    Menu,
    MenuItem,
    Option,
    Panes,
    Previews,
    Printable,
    Textfield,
    LayoutThumbnail,
    Checkmark,
    Styles,
    ImageEditor,
    VueFeather,
    Tile
  },

  props: {
    selectedEditTileIndex: {
      type: Number,
      default: null,
    },
    tiles: {
      type: Array,
      default: null,
    },
    showImageSelector: {
      type: Boolean,
      required: true,
    },
  },

  data () {
    return {
      pane: 'pane_1',
      customSize: false,

      showFlyout: null,
      showPreview: false,
      showConfirmQuit: false,
      showChat: false,
      isMobile: true,
      showFlyoutDesktop: 0,
      renderMode: false,
      PRODUCT_ART_SINGLE_PANEL: products.PRODUCT_ART_SINGLE_PANEL,
      PRODUCT_ART_FRAMED_PRINT: products.PRODUCT_ART_FRAMED_PRINT,
      PRODUCT_COLLAGE_FRAMED_PRINT: products.PRODUCT_COLLAGE_FRAMED_PRINT,
      userManuallySelectedCustom: false,
      flow: null,
      showPicker: false,
      petName: '',
      petInputContent: {
        petName: {
          heading: this.$t('message.builder.petPortraits.name.heading'),
          inputLabel: this.$t('message.builder.petPortraits.name.inputLabel'),
          placeholder: this.$t('message.builder.petPortraits.name.placeholder'),
        },
        petNotes: {
          heading: this.$t('message.builder.petPortraits.notes.heading'),
          inputLabel: this.$t('message.builder.petPortraits.notes.inputLabel'),
          placeholder: this.$t('message.builder.petPortraits.notes.inputPlaceholder'),
          inputPromptEmphasis: this.$t('message.builder.petPortraits.notes.inputPromptEmphasis')
        }
      },
      locale: locale,
      isEditing: false,
    }
  },
  emits: ['close', 'chat', 'saveChanges', 'handlePaneClick'],
  watch: {
    layouts: function (val) {
      if (val) {
        this.showFlyoutDesktop = 99
      }
    },
    isMobile: function (val) {
      if (this.isPetPortraitProduct) {
        this.openMainFlyout()
      }
    },
    showImageSelector: function (shown) {
        if (shown) {
          this.disableKeyEscape()
        } else {
          this.enableKeyEscape()
        }
    }
  },
  computed: {
    ...mapGetters({
      featureFlags: 'app/featureFlags',
      loading: 'builder/loading',
      loadingMessage: 'builder/loadingMessage',
      error: 'builder/error',
      warning: 'builder/warning',
      invalid: 'builder/invalid',
      sizes: 'builder/sizes',
      customWidths: 'builder/customWidths',
      customHeights: 'builder/customHeights',
      customSizesOptions: 'builder/customSizesOptions',
      layouts: 'builder/layouts',
      borders: 'builder/borders',
      borderColors: 'builder/borderColors',
      panes: 'builder/panes',
      edges: 'builder/edges',
      allowedEdges: 'builder/allowedEdges',
      currentEdges: 'builder/currentEdges',
      currentFrames: 'builder/currentFrames',
      supportedFrames: 'builder/supportedFrames',
      filters: 'builder/filters',
      services: 'builder/services',
      filteredSuggestedSizes: 'builder/filteredSuggestedSizes',
      totalPrice: 'builder/totalPrice',
      discountFactor: 'builder/discountFactor',
      coupon: 'builder/coupon',
      couponSizes: 'builder/couponSizes',
      couponAmount: 'builder/couponAmount',
      isSingleSize: 'builder/isSingleSize',
      isArt: 'builder/isArt',
      petPortraitStyles: 'builder/petPortraitStyles',
      petPortraitColors: 'builder/petPortraitColors',
      unitOfMeasure: 'builder/unitOfMeasure',
      productSlug: 'product/productSlug',
      productName: 'product/productName',
      selectedSize: 'product/size',
      selectedWidth: 'product/width',
      selectedHeight: 'product/height',
      totalWidth: 'product/totalWidth',
      totalHeight: 'product/totalHeight',
      selectedLayout: 'product/layout',
      selectedBorder: 'product/border',
      selectedBorderColor: 'product/borderColor',
      selectedEdge: 'product/edge',
      selectedFrame: 'product/frame',
      selectedFilter: 'product/filter',
      selectedService: 'product/service',
      edgeDimension: 'product/edgeDimension',
      note: 'product/note',
      borderDimension: 'product/borderDimension',
      borderColorValue: 'product/borderColorValue',
      gapDimension: 'product/gapDimension',
      matDimension: 'product/matDimension',
      frameDimension: 'product/frameDimension',
      frameColor: 'product/frameColor',
      edgeColor: 'product/edgeColor',
      supportsAr: 'product/supportsAr',
      panels: 'product/panels',
      petPortraitName: 'product/petPortraitName',
      selectedPetPortraitColor: 'product/selectedPetPortraitColor',
      selectedPetPortraitStyle: 'product/selectedPetPortraitStyle',
      options: 'product/options',

      selectedEditToolId: 'image/selectedEditToolId',
      imageEditTrigger: 'image/imageEditTrigger'
    }),

    aspectRatio () {
      if (this.selectedWidth > this.selectedHeight) {
        return dimensions.LANDSCAPE
      } else if (this.selectedWidth < this.selectedHeight) {
        return dimensions.PORTRAIT
      }

      return dimensions.SQUARE
    },

    selectedImages () {
      if (!this.images[this.pane]) {
        return []
      }

      return [this.images[this.pane].id]
    },

    canAddToCart () {
      const panesIds = this.panes.map(pane => pane.id)
      const imageKeys = Object.keys(this.images).filter(v => panesIds.includes(v))

      return (this.uploadLater || (imageKeys.length === panesIds.length)) && (!this.requiresNotes || (this.requiresNotes && this.hasNote))
    },

    isModifying () {
      const { name } = this.$route

      return name === routes.ROUTE_MODIFY
    },

    hasNote () {
      return !!this.note
    },

    addToCartLabel () {
      return this.isModifying ? this.$t('message.builder.addToCartLabel.existing') : this.$t('message.builder.addToCartLabel.new')
    },

    addToCartAriaLabel () {
      return !this.canAddToCart ? 'Choose an image to continue' : 'Total:' + this.$filters.currency(this.totalPrice * (this.hasDiscount ? this.discountFactor : 1))
    },

    canShowAR () {
      const anchor = document.createElement('a')

      return this.supportsAr && supportsAR(anchor) || this.featureFlags && this.featureFlags.enableArTesting
    },

    hasDiscount () {
      return this.discountFactor < 1 && (!this.couponSizes.length || this.couponSizes.indexOf(this.selectedSize) !== -1)
    },

    hasCustomSizes () {
      return this.productSlug &&
        (this.customWidths && this.customHeights || this.customSizesOptions)
    },

    supportsUploadLater () {
      let uploadLater = false

      if (this.productSlug) {
        if (this.productSlug === products.PRODUCT_PET_PORTRAIT && this.enableOffline) {
          uploadLater = true
        } else {
          uploadLater = products.SUPPORTS[this.productSlug].uploadLater
        }
      }

      return uploadLater
    },

    multipleImages () {
      return this.productSlug ? products.SUPPORTS[this.productSlug].multipleImages : false
    },

    allDimensions () {
      return [dimensions.SQUARE, dimensions.PORTRAIT, dimensions.LANDSCAPE, dimensions.PANORAMA]
    },

    sizesByAspectRatio () {
      let groupedSizes = {
        [dimensions.SQUARE]: [],
        [dimensions.PORTRAIT]: [],
        [dimensions.LANDSCAPE]: [],
      }
      if(this.sizes) {
        for (let key in this.sizes) {
          const width = parseInt(this.sizes[key].width)
          const height = parseInt(this.sizes[key].height)
          if (width < height) {
            groupedSizes[dimensions.PORTRAIT].push(`${width}|${height}`)
          } else if (width > height) {
            groupedSizes[dimensions.LANDSCAPE].push(`${width}|${height}`)
          } else {
            groupedSizes[dimensions.SQUARE].push(`${width}|${height}`)
          }
        }
      }
      return groupedSizes
    },

    isCollageProduct () {
      switch(this.productSlug) {
        case products.PRODUCT_COLLAGE_CANVAS_PRINT:
        case products.PRODUCT_COLLAGE_FRAMED_PRINT:

          return true
        default:

          return false
      }
    },

    isFramedProduct () {
      switch(this.productSlug) {
        case products.PRODUCT_FRAMED_PRINT:
        case products.PRODUCT_ART_FRAMED_PRINT:
        case products.PRODUCT_COLLAGE_FRAMED_PRINT:

          return true
        default:

          return false
      }
    },

    isCollageCanvasProduct () {
      return this.productSlug === products.PRODUCT_COLLAGE_CANVAS_PRINT
    },

    isCollageFramedProduct () {
      return this.productSlug === products.PRODUCT_COLLAGE_FRAMED_PRINT
    },

    isPetPortraitProduct () {
      return this.productSlug === products.PRODUCT_PET_PORTRAIT
    },

    showEdgeOptions () {
      return this.edges && Object.keys(this.edges).length > 1
    },

    showFrameOptions () {
      return this.currentFrames && Object.keys(this.currentFrames).length > 1
    },

    widthFactor () {
      return this.productSlug === products.PRODUCT_TRIPTYCH_PRINT ? 3 : 1
    },

    customSizeTriptychSublabel () {
      let sublabel = ''
      if (this.productSlug === products.PRODUCT_TRIPTYCH_PRINT && this.customSize){
        const split = this.selectedSize.split('|')
        const width = parseInt(split[0], 10)
        const height = parseInt(split[1], 10)
        sublabel = this.$t('message.builder.customSizeTriptychSublabel', {width: width, height: height})
      }

      return sublabel
    },

    edgeFrameThumbnailPath () {
      return this.isFramedProduct ? '_' + this.selectedFrame : ''
    },

    frameEdgeThumbnailPath () {
      return this.isFramedProduct ?  '_' + this.selectedEdge : ''
    },

    disableCollageOuterBorder () {
      return this.featureFlags ? this.featureFlags.disableCollageOuterBorder && this.isCollageProduct : false
    },

    borderColorDynamicThumbpath () {

      let thumbpath

      if (this.isCollageProduct) {
        if (this.isCollageCanvasProduct) {
          thumbpath = this.selectedBorder
        } else {
          thumbpath = this.selectedBorder + '_' + this.selectedEdge + '_' + this.selectedFrame
        }
      } else {
        thumbpath = 'RTK'
      }

      return thumbpath
    },

    borderDynamicThumbpath () {

      return this.isCollageFramedProduct ? '_' + this.selectedEdge + '_' + this.selectedFrame : ''
    },

    enableNewPreviewControls () {
      return this.featureFlags?.enableNewPreviewControls
    },

    previewIconClassList () {
      return [
        'py-1 px-2 rounded-full flex items-center space-x-1'
      ]
    },

    enableOffline () {
      return this.featureFlags?.enableOffline
    },

    enableNFT () {
      return this.featureFlags?.enableNFT
    },

    showDimensionControls () {
      // Do not show if:
      // Upload later, edit tool is selected, has a selected image, an offline pet portrait
      return !this.uploadLater && this.enableNewPreviewControls && !this.selectedEditToolId && this.hasImages
    },

    hasImages () {
      return Object.keys(this.images).length !== 0
    },

    canEdit () {
      return this.hasImages && !this.isPetPortraitProduct && this.featureFlags?.enableImageEditor && !this.showPreview
    },

    wrapperPaddingClasslist () {
      if ((this.selectedHeight - 2) / this.selectedHeight > 0.93) {

        return 'px-4 py-12'
      } else if (this.aspectRatio === dimensions.LANDSCAPE && this.isFramedProduct) {

        return 'px-4 py-14'
      } else {

        return 'p-4'
      }
    },

    trapFocusEnabled () {
      return !this.showConfirmQuit && !this.error && !this.warning && !this.invalid && !this.showImageSelector
    },

    selectedTile () {
      return this.selectedEditTileIndex !== null ? this.tiles[this.selectedEditTileIndex] : null
    },

    images () {
      return this.selectedTile.productData.images ? this.selectedTile.productData.images : {}
    },

    uploadLater () {

      return this.selectedTile.productData.uploadLater
    },

    requiresNotes () {

      return this.selectedService !== null
    },

    canSaveChanges () {

      return (!this.selectedService || (this.selectedService && this.hasNote))
    }
  },

  async mounted () {
    await this.init()
    this.focusBuilder()
    document.addEventListener('keydown', this.handleKeyDown)
  },

  unmounted() {
    document.removeEventListener('keydown', this.handleKeyDown)
  },

  beforeUnmount () {
    window.removeEventListener('resize', this.checkForMobile)
    this.disableKeyEscape()
  },

  methods: {
    ...mapActions({
      getProduct: 'builder/getProduct',
      getTileProduct: 'builder/getTileProduct',
      getLineitem: 'builder/getLineitem',
      getArt: 'builder/getArt',
      getSize: 'builder/getSize',
      getImages: 'product/images',
      setImage: 'builder/setImage',
      resetMessages: 'builder/resetMessages',
      cartAdd: 'builder/cartAdd',
      cartUpdate: 'builder/cartUpdate',
      handleStockImage: 'builder/persistStockImage',
      previewInAr: 'builder/previewInAr',
      setError: 'builder/setError',
      setIsSingleSize: 'builder/setIsSingleSize',
      setIsArt: 'builder/setIsArt',
      setCollageSuggestedSizes: 'builder/setCollageSuggestedSizes',
      setPetPortraitOriginalImage: 'builder/setPetPortraitOriginalImage',
      setTrackingMetrics: 'builder/setTrackingMetrics',

      setproductSlug: 'product/setproductSlug',
      setProductImage: 'product/setImage',
      setSize: 'product/setSize',
      setSvg: 'product/setSvg',
      setEdge: 'product/setEdge',
      setFrame: 'product/setFrame',
      setDefaultSizes: 'product/setDefaultSizes',
      setLayout: 'product/setLayout',
      setBorder: 'product/setBorder',
      setBorderColor: 'product/setBorderColor',
      setFilter: 'product/setFilter',
      setService: 'product/setService',
      setUploadLater: 'product/setUploadLater',
      setNote: 'product/setNote',
      setPetPortraitColor: 'product/setPetPortraitColor',
      setPetPortraitStyle: 'product/setPetPortraitStyle',
      setPetPortraitName: 'product/setPetPortraitName',
      resetProduct: 'product/resetProduct',

      cancelEdit: 'image/cancelEdit',
    }),

    async init () {

      this.enableKeyEscape()

      let productSlug = this.selectedTile.productData.productSlug
      const width = parseInt(this.selectedTile.productData.size.split('|')[0], 10)
      const height = parseInt(this.selectedTile.productData.size.split('|')[1], 10)

      // Show an error if the requested product doesn't exist and fall back to a
      // single panel.
      if (!products.DIMENSIONS[productSlug] && productSlug !== products.PRODUCT_METAL_PRINT) {
        productSlug = products.PRODUCT_SINGLE_PANEL

        this.setError(this.$t('message.constants.errors.' + errors.ERROR_WRONG_PRODUCT_CODE))
      }

      this.setproductSlug(productSlug)

      await this.getTileProduct(this.selectedTile)

      // set default sizes
      this.setDefaultSizes(this.sizes)

      window.addEventListener('resize', this.checkForMobile)

      this.checkForMobile()

      await this.hideChat()
    },

    // handleShowOnboarding () {
    //   this.showOnboarding = false
    // },

    checkForMobile () {
      this.isMobile = !window.matchMedia('(min-width: 768px)').matches
    },

    async hideChat  () {
      window?.drift?.api?.widget?.hide?.()
    },

    handleChat () {
      this.$emit('chat')
    },

    handleClose () {
      this.$emit('close')
    },

    handleCloseMessages () {
      this.resetMessages()
    },

    handleShowImageSelector () {
      this.handlePaneClick('pane_1')
    },

    handleShowConfirmQuit () {
      this.showConfirmQuit = true
    },

    openFlyout (index) {
      this.showFlyout = index
      this.showFlyoutDesktop = index
    },

    closeFlyout (index) {
      if (this.showFlyout === index) {
        this.showFlyout = null
      }
    },

    toggleFlyout (index) {
      this.showFlyout = this.showFlyout === index ? null : index
      this.showFlyoutDesktop = index
    },

    openMainFlyout () {
      this.openFlyout(0)
    },

    togglePreview (force) {

      if (typeof force !== 'undefined') {
        this.showPreview = force
      } else {
        this.showPreview = !this.showPreview
      }

      this.renderMode = this.showPreview

    },

    handlePreviewInAr () {
      const svg = document.querySelector('[data-panes]')

      this.previewInAr(serializeSvg(svg))
    },

    handlePaneClick (id) {
      if (!this.isArt && !this.selectedEditToolId) {
        const payload = {
          tileIndex: this.selectedEditTileIndex,
          paneId: id
        }
        this.$emit('handlePaneClick', payload)
      }
    },

    handleSelectSize (size) {
      this.customSize = false
      this.getSize({ code: this.productSlug, width: parseInt(size.width, 10), height: parseInt(size.height, 10) })
    },

    handleSelectEdge (edge) {
      this.setEdge(edge.code)
    },

    handleSelectFrame (frame) {
      this.setFrame(frame.code)
    },

    handleSelectLayout (layout) {
      // update size based on dimension
      if (layout.formfactor !== this.aspectRatio && !this.customSize) {
        let formfactor = layout.formfactor === dimensions.PANORAMA ? dimensions.LANDSCAPE : layout.formfactor
        this.setCollageSuggestedSizes({suggestedSizes: this.sizesByAspectRatio[formfactor].slice(0, 4), fromLineItem: false})
      }

      this.setLayout(layout.code)
    },

    handleSelectBorder (border) {
      this.setBorder(border.code)
    },

    handleSelectBorderColor (borderColor) {
      this.setBorderColor(borderColor.code)
      if (this.productSlug === products.PRODUCT_COLLAGE_CANVAS_PRINT) {
        this.setEdge(borderColor.code)
      }
    },

    handleSelectFilter (filter) {
      this.setFilter(filter.code)
    },

    handleSelectService (service) {
      this.setService(service.code)
    },

    handleUploadLater () {
      this.tiles[this.selectedEditTileIndex].productData.uploadLater = true
      this.setUploadLater(true)
    },

    handleSelectCustomSize () {
      this.customSize = true
    },

    handleCustomWidth (index) {
      const { value } = this.customWidths[index]
      const width = value / this.widthFactor
      this.getSize({ code: this.productSlug, width: width, height: this.selectedHeight })
      this.handleUserManualSelectCustomSize()
    },

    handleCustomHeight (index) {
      const { value } = this.customHeights[index]
      const width = this.selectedWidth / this.widthFactor
      this.getSize({ code: this.productSlug, width: width, height: value })
      this.handleUserManualSelectCustomSize()
    },

    handleCustomSize (index) {
      const { value } = this.customSizesOptions[index]

      const size = value.split('|')
      const width = parseInt(size[0], 10)/ this.widthFactor
      const height = parseInt(size[1], 10)

      this.getSize({ code: this.productSlug, width: width, height: height })
      this.handleUserManualSelectCustomSize()
    },

    handleNameChange() {
      this.setPetPortraitName(this.petName)
    },

    handleNoteChange (note) {
      this.setNote(note)
    },

    totalSizePrice (size) {
      let sizePrice = 0
      let framePrice = 0

      if (size && this.sizes) {
        sizePrice = this.sizes[size].foreignPrice
        framePrice = this.selectedFrame ? this.sizes[size].frames[this.selectedFrame].foreignPrice : 0
      }

      return sizePrice + framePrice
    },

    framePriceDifference (frame) {
      let framePrice = 0
      let includedFramePrice = 0

      if (frame) {
        framePrice = frame.foreignPrice
        if (this.currentFrames && this.currentFrames['075DW']) {
          includedFramePrice = this.currentFrames['075DW'].foreignPrice
        }
      }

      return framePrice - includedFramePrice
    },

    hasDiscountForSize (size) {
      return this.discountFactor < 1 && (!this.couponSizes.length || this.couponSizes.indexOf(size) !== -1)
    },

    getThumbnailAspectRatio (size) {
      let width = parseInt(size.width, 10)
      const height = parseInt(size.height, 10)

      if (this.productSlug === products.PRODUCT_TRIPTYCH_PRINT) {
        width = width * 3
      }

      if (width > height) {
        return dimensions.LANDSCAPE
      } else if (width < height) {
        return dimensions.PORTRAIT
      }

      return dimensions.SQUARE
    },

    /**
     * @todo use these methods to create fully dynamic thumbnail previews (where
     * the canvas has a real aspect ratio and size).
     */
    getThumbnailSize (size, index) {
      if (!this.isSingleSize) {
        return index
      }

      const width = parseInt(size.width, 10)
      const height = parseInt(size.height, 10)
      const widthAspect = Math.round(width / 72 * 4) - 1
      const heightAspect = Math.round(height / 72 * 4) - 1

      if (width >= height) {
        return widthAspect
      } else if (width < height) {
        return heightAspect
      }
    },

    handleKeyEscape (event) {
      const key = 'which' in event ? event.which : event.keyCode
      if (key === 27) {
        this.saveTileChanges()
      }
    },

    handleUserManualSelectCustomSize() {
      if (!this.userManuallySelectedCustom) {
        this.setTrackingMetrics({userManuallySelectedCustom: true})
      }
    },

    getAdditionalLengthHeading(width, height) {
      let additionalLength = 0
      switch (this.selectedFrame) {
        case 'BF':
        case 'WF':
        case 'EF':
          // add frame thickness
          additionalLength += this.frameDimension * 2
          if (this.selectedEdge === '250MA') {
            // add mat thickness
            additionalLength += this.matDimension * 2
          } else if (this.selectedEdge !== '250MA' && this.selectedEdge !== 'NOMA') {
            // add gap thickness for float frames
            additionalLength += this.gapDimension * 2
          }
          break
        default:
          break
      }

      // add additional length to selected width and height
      if (additionalLength > 0) {
        let totalWidth = parseInt(width) + additionalLength
        let totalHeight = parseInt(height) + additionalLength

        let multiplier = 1
        let unitLabel
        switch (this.unitOfMeasure) {
          case measurements.UNIT_CENTIMETERS:
            totalWidth = Math.round(totalWidth * 2.54)
            totalHeight = Math.round(totalHeight * 2.54)
            unitLabel = ' cm'
            break
          case measurements.UNIT_INCHES:
          default:
            unitLabel = '"'
        }

        return '(' + totalWidth + unitLabel + ' x ' + totalHeight + unitLabel + ' <span class="whitespace-nowrap">' + this.$t('message.builder.flyout.sizes.additionalLengthHeadingSuffix') + '</span>)'
      } else {

        return null
      }
    },

    liveFilterAvailable (filter) {

      return ['BW', 'SP', 'VT'].includes(filter) && this.hasImages
    },

    focusBuilder() {
      this.$nextTick(() => {
        // focus on the builder component on mount
        let builder = this.$refs.builder
        builder?.focus()
      })
    },

    handleKeyDown (event) {
      if (this.trapFocusEnabled) {
        trapTabFocus(this.$refs.builder, this.$refs.backButton.$el, event)
      }
    },

    removePrintableTransform (el) {
      if (el) el.style.transform = 'none'

      return el
    },

    getParsedSvg () {
      let el = document.querySelector('#printable')
      el = this.removePrintableTransform(el)
      const svg = sanitizeSvg(serializeSvg(el))

      return parseSvg(svg)
    },

    saveTileChanges () {
      this.cancelEdit()
      let productData = this.selectedTile.productData
      const parsedSvg = this.getParsedSvg()

      if (parsedSvg) {
        Object.keys(parsedSvg).forEach(key => {
          productData.images[key] = Object.assign({}, productData.images[key], parsedSvg[key])
        })
      }
      productData.size = this.selectedSize
      productData.options = this.options
      productData.note = this.note

      this.$emit('saveChanges')
    },

    disableKeyEscape () {
      document.removeEventListener('keyup', this.handleKeyEscape)
    },

    enableKeyEscape () {
      document.addEventListener('keyup', this.handleKeyEscape)
    }
  },
}
</script>
